import React, { Component } from 'react'
import { Button, Form, ButtonGroup, FormGroup, Input, Label, Row, Col } from 'reactstrap'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import { getUserPermissions } from '../../../utils/userPermissions'
// import {withGaTracker, withGaEvent} from '../../Support/GoogleAnalytics'
import BlockWithLoader from '../../Support/BlockWithLoader'
import { SwitchRadioBtn } from '../../Support/index'

export const exportDefaultFormatKey = 'exportFormat'

const exportFormats = [{ name: 'Csv', value: 'csv' }, { name: 'Pdf', value: 'pdf' }]
const certificateView = [{ name: 'Test designation ', value: 'show_certificates' },
{ name: 'Range of qualifications', value: 'show_approvals' },
{ name: 'All', value: '' }]

const allGridColumns = {
  element: 'Element',
  no: 'Weld No',
  weld_type: 'Weld type',
  length: 'Length',
  diameter_1: 'Diameter 1',
  thickness_1: 'Thickness 1',
  diameter_2: 'Diameter 2',
  thickness_2: 'Thickness 2',
  material_1: 'Material 1',
  material_2: 'Material 2',
  inspection_category: 'Inspection category',
  wps: 'WPS',
  welding_progress: 'Welding',
  welder: 'Welder',
  welding_consumables: 'Welding Consumables',
  status: 'Status',
  actions: 'Actions'
}

class SettingsForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      disabled_columns: JSON.parse(localStorage.getItem('weldsGridDisabledColumns')) || { basics: [], inspections: [] },
      filter_welders: localStorage.getItem('weldsGridFilterWelders') === 'true',
      filter_wps: localStorage.getItem('weldsGridFilterWps') === 'true',

      export_format: localStorage.getItem(exportDefaultFormatKey),
      merge_by_cert_no: localStorage.getItem('CertificatesMergeByNo') === 'true',
      certificate_view: localStorage.getItem('CertificatesView') || '',
    }

    this.permited_columns = getUserPermissions('wl_welds.welds.grid_columns') || []
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    onCancel: PropTypes.func,
    afterSubmit: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
  }

  componentDidMount() {
    // withGaTracker(window.location.pathname + '/settings_form') // GA TRACKER
  }

  handleSubmit(e) {
    e.preventDefault()
    localStorage.setItem('weldsGridDisabledColumns', JSON.stringify(this.state.disabled_columns))
    localStorage.setItem('weldsGridFilterWelders', this.state.filter_welders)
    localStorage.setItem('weldsGridFilterWps', this.state.filter_wps)

    localStorage.setItem(exportDefaultFormatKey, this.state.export_format)
    localStorage.setItem('CertificatesMergeByNo', this.state.merge_by_cert_no)
    localStorage.setItem('CertificatesView', this.state.certificate_view)

    // withGaEvent({category: 'Grid Settings', action: 'save'}) // GA EVENT
    this.props.afterSubmit()
  }

  onColumnCheckboxBtnClick(selected, type) {
    let newDisabledColumns = this.state.disabled_columns
    const index = newDisabledColumns[type].indexOf(selected)
    if (index < 0) {
      newDisabledColumns[type].push(selected)
    } else {
      newDisabledColumns[type].splice(index, 1)
    }

    this.setState({ disabled_columns: newDisabledColumns })
  }

  renderColumnsList() {
    return (
      <Col md="6">
        {Object.entries(allGridColumns).map((col, i) =>
          <FormGroup key={i} check>
            <Label check>
              <Input type="checkbox" id={col[0]}
                disabled={!['element', 'actions'].includes(col[0]) && !this.permited_columns.includes(col[0])}
                checked={!this.state.disabled_columns.basics.includes(col[0])}
                onChange={() => this.onColumnCheckboxBtnClick(col[0], 'basics')}
              /> {col[1]}
            </Label>
          </FormGroup>
        )}
      </Col>
    )
  }

  renderInspectionsList() {
    let inspectionsChecked = this.state.disabled_columns.inspections.length === 0
    return (
      <Col md="6">
        <FormGroup check>
          <Label check>
            <Input type="checkbox" id="inspections_all"
              disabled={!this.permited_columns.includes('inspections')}
              checked={inspectionsChecked}
              onChange={() => {
                let newDisabledColumns = this.state.disabled_columns
                newDisabledColumns['inspections'] = (inspectionsChecked ? this.props.data.inspection_category_types.map(o => o.id) : [])
                this.setState({ disabled_columns: newDisabledColumns })
              }}

            /> Inspections
          </Label>
        </FormGroup>

        {this.props.data.inspection_category_types.map((inspType) =>
          <FormGroup key={inspType.id} check>
            <Label check>
              <Input type="checkbox" id={inspType.id}
                disabled={!this.permited_columns.includes('inspections')}
                checked={!this.state.disabled_columns.inspections.includes(inspType.id)}
                onChange={() => this.onColumnCheckboxBtnClick(inspType.id, 'inspections')}
              /> {inspType.name}
            </Label>
          </FormGroup>
        )}
      </Col>
    )
  }

  renderFilterList() {
    return (
      <Row>
        <Col md="12">
          <h6>Set the default filters:</h6>
          {[{ key: 'filter_welders', label: 'Welders by qualifications' },
          { key: 'filter_wps', label: 'Wps by weld requirements' }].map(option =>
            <Row key={option.key}>
              <Col>
                <SwitchRadioBtn
                  label={option.label}
                  checked={this.state[option.key]}
                  onChangeFunc={() => this.setState({ [option.key]: !this.state[option.key] })}
                />
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    )
  }

  render() {
    if (this.props.data.error) return <div>An unexpected error occurred</div>

    return (
      <BlockWithLoader loading={this.props.data.loading} renderChildren={true}>
        {!this.props.data.loading &&
          <Form className="FormClassLabel" onSubmit={this.handleSubmit}>
            <Row className='p-1 border border-light rounded'>
              <Col md="12" className='text-center'><h4>Welds grid</h4></Col>
              <Col md="12">
                {this.renderFilterList()}
                <Row>
                  <Col md="12">
                    <h6>Uncheck the columns you do not want to see:</h6>
                  </Col>
                  {this.renderColumnsList()}
                  {this.renderInspectionsList()}
                </Row>
              </Col>
            </Row>

            <Row className='p-1 border border-light rounded'>
              <Col md="12" className='text-center'><h4>Exports</h4></Col>
              <Col md="12">
                <h6>Set the default export format:</h6>
                {exportFormats.map(option =>
                  <FormGroup key={option.value} inline check>
                    <Label check>
                      <Input type="radio" name="export_format"
                        checked={this.state.export_format === option.value}
                        onChange={() => this.setState({ export_format: option.value })} />
                      {` ${option.name}`}
                    </Label>
                  </FormGroup>
                )}
              </Col>
            </Row>

            <Row className='p-1 border border-light rounded'>
              <Col md="12" className='text-center'><h4>Welder certificates</h4></Col>
              <Col md="12">
                <h6>Set the default certificates view:</h6>
                <Row>
                  <Col md="12">
                    <SwitchRadioBtn label='Group certificates by No' checked={this.state.merge_by_cert_no}
                      onChangeFunc={() => this.setState({ merge_by_cert_no: !this.state.merge_by_cert_no })} />
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    {certificateView.map(option =>
                      <FormGroup key={option.value} inline check>
                        <Label check>
                          <Input type="radio" name="certificate_view"
                            checked={this.state.certificate_view === option.value}
                            onChange={() => this.setState({ certificate_view: option.value })} />
                          {` ${option.name}`}
                        </Label>
                      </FormGroup>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>

            <br />
            <ButtonGroup className='float-right'>
              {this.props.afterSubmit && <Button id="save-grid-settings-btn" color="primary" type='submit'>Save</Button>}
              {this.props.onCancel && <Button id="close-grid-settings-btn" color="danger" type='button' onClick={this.props.onCancel}>Cancel</Button>}
            </ButtonGroup>
            <br />
          </Form>}
      </BlockWithLoader>
    )
  }
}

const InspectionCategoriesDictQuery = gql`
  query InspectionCategoriesDictQuery {
    inspection_category_types {
      id
      name
    }
  }
`

const GridSettingsFormWithData = graphql(InspectionCategoriesDictQuery, {
  options: {
    fetchPolicy: 'network-only'
  },
})(SettingsForm)

export default GridSettingsFormWithData



// WEBPACK FOOTER //
// ./src/components/Profile/settings/SettingsForm.js